import React, { useState } from "react";
import { API_CONFIG } from "../config/api";

const {
  GoogleGenerativeAI,
} = require("@google/generative-ai");

const genAI = new GoogleGenerativeAI(API_CONFIG.GEMINI.API_KEY);

  const model = genAI.getGenerativeModel({
  model: "gemini-2.5-flash",
  systemInstruction: `
  Return ONLY:
  Time: O(...), Space: O(...)
  No explanation. Max 10 words.
  `,
  });

  const generationConfig = {
    temperature: 0,
    topP: 0.95,
    topK: 40,
    maxOutputTokens: 8192,
    responseMimeType: "text/plain",
  };

const Gemini = ({code }) => {
  const [spaceTime, setSpaceandTime] = useState("Run code to analyze complexity");
  const [loading, setLoading] = useState(false);

  const handleCode = async () => {
    setLoading(true);
    
    try {
      async function run() {
        const chatSession = model.startChat({
          generationConfig,
          history: [],
        });
    
        await chatSession.sendMessage(code).then((res) => {
          console.log(res);
          setSpaceandTime(res.response.text());
        });
      }
      await run();
    } catch (error) {
      setSpaceandTime("Error analyzing complexity");
      console.error("Gemini API error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={handleCode}
        disabled={loading}
        className="px-3 py-1.5 text-sm font-medium rounded-md border transition-all transform hover:scale-105 active:scale-95"
        style={{
          backgroundColor: loading ? '#6b7280' : '#8b5cf6',
          color: '#ffffff',
          borderColor: '#8b5cf6',
          cursor: loading ? 'not-allowed' : 'pointer',
          opacity: loading ? 0.7 : 1,
          transition: '200ms ease-in-out'
        }}
        onMouseEnter={(e) => {
          if (!loading) {
            e.target.style.backgroundColor = '#7c3aed';
          }
        }}
        onMouseLeave={(e) => {
          if (!loading) {
            e.target.style.backgroundColor = '#8b5cf6';
          }
        }}
      >
        {loading ? (
          <span className="flex items-center space-x-1">
            <div className="w-3 h-3 border border-white border-t-transparent rounded-full animate-spin" />
            <span>Analyzing...</span>
          </span>
        ) : (
          <span className="flex items-center space-x-1">
            <span>⚡</span>
            <span>Analyze</span>
          </span>
        )}
      </button>
      
      {spaceTime && (
        <div 
          className="px-3 py-1.5 text-sm rounded-md border"
          style={{
            backgroundColor: '#1f2937',
            borderColor: '#374151',
            color: '#e5e7eb',
            fontFamily: 'monospace',
            maxWidth: '300px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={spaceTime}
        >
          {spaceTime}
        </div>
      )}
    </div>
  );
};

export default Gemini;
